<template>
	<div class="row principal">
		<sidebar :on-contraer="onContraer" :on-accion="onAccion" :key="'sidebar_' + periodo"></sidebar>
		<general v-if="general" :contraer="contraer"></general>
		<panel v-if="!general" :accion="accion" :info="info" :contraer="contraer" :on-cerrar="onCerrar"></panel>
	</div>
</template>
<script lang="ts">

	import $ from "jquery"
	import Sidebar from "./sidebar.vue"
	import General from "./general.vue"
	import Panel from "./panel.vue"


	export default {
		name: "Facturacion",
		components: { Sidebar, General, Panel },
		props: {
			menu: String // Variable que guarda el menu seleccionado
		},
		data() {
			return {
				periodo: "",
				contraer: true, // Variable que controla si la barra lateral se ha contraido/expandido para avisar al panel de datos
				general: true,
				accion: "",
				info: "",
			}
		},
		computed: {

			getPanel: function() {

				return this.panel
			}
		},
		mounted: function() {

			const that = this

			window.event.$on("evento-cambio-periodo", function(periodo) {

				that.periodo = periodo
			})
		},
		methods: {

			onContraer(contraer) {

				this.contraer = contraer
			},

			onAccion(accion, info) {

				this.general = false
				this.accion = accion
				this.info = info
			},

			// Si se cierra un panel, se activa el panel general mediante este metodo
			onCerrar() {

				this.general = true 
				this.accion = ""

				$(".ficha").removeClass("ficha-activa")
			},
		}
	}

</script>
<style scoped>

	.principal {
		width: 100%;
		margin-right: 0 !important;
		margin-left: 0 !important;
	}

</style>
